if (!customElements.get('pastael-card-product')) {
  class PastaelCardProduct extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.cardLink = this.querySelector('[data-card-link]');
      this.titleLink = this.querySelector('.pastael-card-product__title-link');
      this.price = this.querySelector('[data-card-price]');
      this.addPrice = this.querySelector('[data-card-add-price]');
      this.size = this.querySelector('[data-card-size]');
      this.quickAddButton = this.querySelector('[data-quick-add]');
      this.colorLists = this.querySelectorAll('.pastael-card-product__colors');
      this.media = this.querySelector('.pastael-card-product__media');
      this.mediaStage = this.querySelector('[data-card-media-stage]');

      this.onSwatchActivate = this.onSwatchActivate.bind(this);
      this.onMediaClick = this.onMediaClick.bind(this);

      this.colorLists.forEach((colors) => {
        colors.addEventListener(
          'mousedown',
          (event) => {
            if (event.target.closest('[data-variant-id]')) {
              event.preventDefault();
              event.stopPropagation();
            }
          },
          true
        );
        colors.addEventListener('click', this.onSwatchActivate, true);
        colors.addEventListener(
          'touchstart',
          (event) => {
            if (event.target.closest('[data-variant-id]')) {
              event.preventDefault();
              event.stopPropagation();
              this.onSwatchActivate(event);
            }
          },
          { capture: true, passive: false }
        );
      });

      if (this.media) {
        this.media.addEventListener('click', this.onMediaClick);
      }

      if (this.mediaStage) {
        this.initGallery();
      }
    }

    initGallery() {
      if (!window.PastaelColorMediaGallery) {
        window.requestAnimationFrame(() => this.initGallery());
        return;
      }

      if (this.gallery) return;

      const preferredMediaId =
        this.querySelector('.pastael-card-product__media-slide.is-active')?.dataset.mediaId || '';
      this.gallery = new window.PastaelColorMediaGallery(this, {
        stage: this.mediaStage,
      });
      this.gallery.init(this.dataset.activeColor || '', preferredMediaId);
    }

    disconnectedCallback() {
      this.gallery?.destroy();
    }

    onSwatchActivate(event) {
      const swatch = event.target.closest('[data-variant-id]');
      if (
        !swatch ||
        !Array.from(this.colorLists).some((colors) => colors.contains(swatch))
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      this.selectVariant(swatch);
    }

    onMediaClick(event) {
      if (event.target.closest('[data-variant-id], [data-card-media-prev], [data-card-media-next]')) return;
      if (this.gallery?.dragState || this.gallery?.hadRecentSwipe) return;

      if (this.cardLink?.href) {
        window.location.assign(this.cardLink.href);
      }
    }

    selectVariant(swatch) {
      const { variantId, variantUrl, variantPrice, sizeValue, colorValue, variantMediaId } = swatch.dataset;

      this.querySelectorAll('[data-variant-id]').forEach((item) => {
        const isActive = item.dataset.variantId === variantId;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (this.cardLink && variantUrl) {
        this.cardLink.href = variantUrl;
      }

      if (this.titleLink && variantUrl) {
        this.titleLink.href = variantUrl;
      }

      if (this.price && variantPrice) {
        this.price.textContent = variantPrice;
      }

      if (this.addPrice && variantPrice) {
        this.addPrice.textContent = variantPrice;
      }

      if (this.size && sizeValue) {
        this.size.textContent = sizeValue;
      }

      if (this.quickAddButton && variantId) {
        this.quickAddButton.dataset.quickAdd = variantId;
      }

      if (this.gallery && colorValue) {
        this.dataset.activeColor = colorValue;
        this.gallery.filterByColor(colorValue, variantMediaId || '', true);
      }

      this.dataset.activeVariantId = variantId;
    }
  }

  customElements.define('pastael-card-product', PastaelCardProduct);
}
